var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticClass:"U--margin-auto U--unset-float",attrs:{"lg":6,"md":8,"sm":10}},[_c('el-button',{staticClass:"U--full-width",attrs:{"type":"warning","plain":""},nativeOn:{"click":function($event){_vm.openModal('addDataGroup')}}},[_vm._v("Add Data Group")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1381d4dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BtnAddDataGroup.vue
// module id = null
// module chunks = 